import { useParams } from 'react-router-dom';

import useHashmapConverter from 'hooks/useHashmapConverter';

import { ProgramStatusUrlParams } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramStatusSummaryReport/programStatusSummaryReportTypes';

export const useGetVersionIdAndCompareId = () => {
    const { id, versionToCompareId } = useParams<ProgramStatusUrlParams>();
    const hashcode = [id, versionToCompareId].filter((v): v is string => Boolean(v)).join(',');
    const { versionList: versionFromHashMap } = useHashmapConverter(hashcode);
    const versionId = versionFromHashMap[0]?.versionDbId;
    const compareVersionId = versionFromHashMap[1]?.versionDbId;
    return {
        versionId,
        compareVersionId,
    };
};
